type Props = {
  width?: string | number;
  height?: string | number;
  strokeColor?: string;
};

const CloseIcon = (props: Props) => {
  const { width = 12, height = 12, strokeColor = 'currentColor' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M11 1 1 11M1 1l10 10"
        stroke={strokeColor}
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;
